import { Tag } from "primereact/tag";
import { Divider } from "primereact/divider";
import Detail from "../../common/Detail";
import { getReadableDate } from "../../../utils";
import { TEXT_SMALL } from "../../../style";

export default function WebsiteInquiryCard({
    id,
    full_name,
    phone,
    branch_name,
    course_title,
    description,
    created_at,
    source = "website",
}) {
    return (
        <div className="bg-white border-round-md shadow-3 mb-2 p-3" key={id}>
            <div className="flex justify-content-between align-items-center">
                <div className="flex flex-column gap-2">
                    <span>
                        {id}. {full_name || "Inquiry"}
                    </span>
                    <div className={`flex align-items-center gap-1 ${TEXT_SMALL}`}>
                        <span className="pi pi-calendar" />
                        <span>{getReadableDate({ date: created_at })}</span>
                    </div>
                    <div className={`flex align-items-center gap-1 ${TEXT_SMALL}`}>
                        <span className="pi pi-globe" />
                        <span>Source {source || "website"}</span>
                    </div>
                </div>

                <Tag severity="info" value="Website" />
            </div>

            <Divider />

            <div className="flex mt-2 align-items-center flex-wrap">
                {full_name && <Detail className="flex-1" title="Name" value={full_name} icon="pi pi-user" />}
                {phone && <Detail className="flex-1" title="Contact" value={phone} icon="pi pi-phone" />}
            </div>

            <div className="flex mt-2 align-items-center flex-wrap">
                {branch_name && <Detail className="flex-1" title="Branch" value={branch_name} icon="pi pi-building" />}
                {course_title && <Detail className="flex-1" title="Course" value={course_title} icon="pi pi-book" />}
            </div>

            {description ? (
                <div className="flex mt-2 align-items-center">
                    <Detail className="flex-1" title="Note" value={description} icon="pi pi-align-left" />
                </div>
            ) : null}
        </div>
    );
}
